module.exports = __webpack_public_path__ + "static/media/vietnamese-noodle-bar.80fb0ad5.jpg";